import React from 'react';

export const UserSvg = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 231 238"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.999 238H0.0010376C0.000305176 237.833 0 237.667 0 237.5C0 192.01 26.2982 152.662 64.5208 133.831C78.5941 145.195 96.5024 152 116 152C135.322 152 153.082 145.317 167.097 134.137C204.985 153.087 231 192.256 231 237.5C231 237.667 231 237.833 230.999 238Z"
        fill="rgba(9, 132, 255, 0.4)"
      />
      <path
        d="M183 67C183 104.003 153.003 134 116 134C78.9969 134 49 104.003 49 67C49 29.9969 78.9969 0 116 0C153.003 0 183 29.9969 183 67Z"
        fill="rgba(9, 132, 255, 0.4)"
      />
    </svg>
  );
};
